module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAS1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////+DmQsHAAAAGHRSTlMAECAwP0Bgb3B/gJCfoK+wv8DP0N/g7/CvbumZAAAArElEQVQ4y+XTyQ6DMAxFUTuUoUBLnQC5//+lXaAylDQrdn276B3JUiyLXJzC+yILHjBkgYH9Nyj6u66gfZ7/M4DXBWgP4wkMgFcDUw9M5xER8AGCB2JiZcXEmphcqYZkX/H6FltvVDJBeRTBfd4ljMIOiAYIKjvAEYg27danwDElIDEPohi0v0ADJh3Mmu51hE4cMNe3ROoRcCItmTQiWdEss1xnqdY6d8k5vwFCWBero2dG1wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgnew/i-download.png
// module id = tcV7
// module chunks = 1